import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import OurIdentityImg1 from "../../assets/inves-img1.jpg";
import AboutInvestingImg1 from "../../assets/inves-img2.jpg";
import * as apiUrl from "../../apiUrl";

function InvestingDescription({ seconddata, thirddata, fourthdata }) {
  const second_section_descriptions = seconddata.section_description
    ? JSON.parse(seconddata.section_description)
    : [];

  const fourth_section_descriptions = fourthdata.section_description
    ? JSON.parse(fourthdata.section_description)
    : [];
  return (
    <section className="privacy-description-sec about-inner-page-desc">
      <Container fluid>
        <Row className="flex-center about-our-identity-row">
          <Col md={6}>
            <img
              src={apiUrl.apiUrl + `/` + seconddata.section_image}
              className="img-fluid"
              alt="Buy Dubai property from abroad"
              data-aos="fade-right"
            />
          </Col>
          <Col md={6}>
            <div className="about-investing-content-div" data-aos="fade-left">
              <h2
                className="common-head goldenColor"
                dangerouslySetInnerHTML={{ __html: seconddata.section_title }}
              ></h2>
              {second_section_descriptions.map((desc, index) => (
                <p className="common-para">{desc}</p>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
      <Container fluid className="wrap  identity-new-page-container">
        <Row>
          <Col md={12}>
            <div className="privacy-desc-div" dangerouslySetInnerHTML={{ __html: thirddata.description }}>
              {/* <h6 data-aos="fade-up">
                1. Peace of Mind Through Quality & Craftsmanship
              </h6>

              <ul data-aos="fade-up">
                <li>
                  <p className="common-para">
                    {" "}
                    <b>What it means:</b> You are investing in a home that is
                    built to last. This means fewer worries about leaks, cracks,
                    electrical issues, or appliance failures in the first few
                    years.
                  </p>
                </li>
                <li>
                  <p className="common-para">
                    {" "}
                    <b>Home Buyer Benefit: </b> You can enjoy your new home
                    instead of constantly fixing it. This is especially valuable
                    for first-time buyers who may not have the budget or
                    expertise for unexpected repairs.
                  </p>
                </li>
              </ul>

              <h6 data-aos="fade-up">
                2. A Thoughtfully Designed Living Experience
              </h6>

              <ul data-aos="fade-up">
                <li>
                  <p className="common-para">
                    {" "}
                    <b>What it means:</b> Marquis homes are likely designed with
                    modern life in mind – open-plan living, efficient use of
                    space, ample storage and good natural light.
                  </p>
                </li>
                <li>
                  <p className="common-para">
                    {" "}
                    <b>Home Buyer Benefit: </b> The home works for you. It
                    enhances your daily life, whether it’s space for a growing
                    family, a layout perfect for entertaining, or a quiet corner
                    for relaxation. This is about buying a lifestyle, not just
                    square footage.
                  </p>
                </li>
              </ul>
              <h6 data-aos="fade-up">3. Vibrant Community and Amenities</h6>
              <ul data-aos="fade-up">
                <li>
                  <p className="common-para">
                    {" "}
                    <b>What it means:</b> Buying into a Marquis development
                    means access to amenities like gyms, kids’ play areas,
                    swimming pools, jogging tracks, padel courts, and so on.
                  </p>
                </li>
                <li>
                  <p className="common-para">
                    {" "}
                    <b>Home Buyer Benefit: </b> This instantly provides a social
                    fabric and enhances your quality of life without having to
                    leave your building. It’s a huge value-add for families as
                    well as individuals seeking connection and a sense of
                    belonging with the community.
                  </p>
                </li>
              </ul>
              <h6 data-aos="fade-up">
                4. Energy Efficiency & Lower Running Costs
              </h6>
              <ul data-aos="fade-up">
                <li>
                  <p className="common-para">
                    {" "}
                    <b>What it means:</b> At Marquis, conserving energy is a
                    priority. We install energy-star rated appliances, better
                    insulation and water-saving fixtures wherever applicable.
                  </p>
                </li>
                <li>
                  <p className="common-para">
                    {" "}
                    <b>Home Buyer Benefit: </b> Saving energy means saving on
                    your utility bills. Furthermore, you harness a sustainable
                    lifestyle which is better for the environment.
                  </p>
                </li>
              </ul>
              <h6 data-aos="fade-up">
                5. A Sound Long-Term Financial Decision
              </h6>
              <ul data-aos="fade-up">
                <li>
                  <p className="common-para">
                    {" "}
                    <b>What it means:</b> While you're buying a living space,
                    your home is also your most significant asset.
                  </p>
                </li>
                <li>
                  <p className="common-para">
                    {" "}
                    <b>Home Buyer Benefit: </b> Properties built by Marquis
                    Developers have already established a proven track record of
                    appreciating better than the market average. When it comes
                    time to upgrade or move, you will have built more equity,
                    making your next home even more affordable.
                  </p>
                </li>
              </ul> */}
            </div>
          </Col>
        </Row>
      </Container>
      <Container fluid className="about-investing-container">
        <Row className="flex-center about-investing-row">
          <Col md={6}>
            <div className="about-investing-content-div" data-aos="fade-right">
              <h2 className="common-head goldenColor" dangerouslySetInnerHTML={{ __html: fourthdata.section_title }}>              
              </h2>

              {fourth_section_descriptions.map((desc, index) => (
                <p className="common-para" dangerouslySetInnerHTML={{ __html: desc }}></p>
              ))}
            </div>
          </Col>
          <Col md={6}>
            <img
              src={apiUrl.apiUrl + `/` + fourthdata.section_image}
              className="img-fluid"
              alt="New property launches Dubai"
              data-aos="fade-left"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}
export default InvestingDescription;
